(function () {
    'use strict';

    angular.module("imApp").factory("prodGrpMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 917,
                    parameters: parms || {}
                });
            },
            treeListProductGroups: function (parms) {
                return $ihttp.post({
                    method: 3084,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();